import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 7h5l3.5 5h9.5","key":"svg-0"}],["path",{"d":"M3 17h5l3.495 -5","key":"svg-1"}],["path",{"d":"M18 15l3 -3l-3 -3","key":"svg-2"}]]

/**
 * IconArrowsJoin
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3dzLWpvaW4iCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTMgN2g1bDMuNSA1aDkuNSIgLz4KICA8cGF0aCBkPSJNMyAxN2g1bDMuNDk1IC01IiAvPgogIDxwYXRoIGQ9Ik0xOCAxNWwzIC0zbC0zIC0zIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/arrows-join
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowsJoin = createReactComponent('outline', 'arrows-join', 'ArrowsJoin', __iconNode);

export default IconArrowsJoin;